import React from 'react';
import { Box, Typography } from '@mui/material';
import { palette, spaces } from '../../assets/styles/themes/tokens';
import { AddMenuButton, MuiCardBaseProps } from '../cards/MuiCard/MuiCardBase/MuiCardBase';
import { Product } from '@klab-berlin/api-sdk/lib/types/responses/Product';
import { MindItem } from '@klab-berlin/api-sdk/lib/types/responses/MindItem';
import { Alert } from '../NotificationAlert/NotificationAlert';

const SummaryTitle: React.FC<{
  itemId: string;
  itemData: Partial<Product> | Partial<MindItem>;
  type: MuiCardBaseProps['contentType']
  title: string;
  onShowNotification?: (alert: Alert) => void;
}> = ({ itemId, itemData, title, type, onShowNotification }) => (
  <Box
    sx={{
      color: palette.text.primary,
      padding: `${spaces.md} 0px`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    }}
    data-testid='summary-title'
  >
    <Typography variant='h5'>{title}</Typography>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: spaces.xs,
      }}
    >
      <AddMenuButton
        isPinned={!!itemData.isPinned}
        id={itemId}
        itemData={itemData}
        type={type}
        onShowNotification={onShowNotification}
        buttonSx={{
          position: 'relative',
          top: 'unset',
          right: 0,
        }}
      />
    </Box>
  </Box>
);

export default SummaryTitle;
